import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsApplicationdefsService } from './edit-dialogs-applicationdefs.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-applicationdefs',
  templateUrl: './edit-dialogs-applicationdefs.component.html',
  styleUrls: ['./edit-dialogs-applicationdefs.component.scss']
})
export class EditDialogsApplicationdefsComponent implements OnInit {

  /** Subscripción para el guardado de un applicationdef */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsApplicationdefsService: EditDialogsApplicationdefsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsApplicationdefsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsApplicationdefsService.build(); }

  ngOnInit() {
    this.editDialogsApplicationdefsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
    this.defaultLabel = this.translateService.instant('TABLAS.no_hay_typefinders');
  }

  /**
  * @description
  * Guardar el Applicationdef
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsApplicationdefsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del applicationdef está ausente
      // -1: El número del applicationdef ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorApplicationsDefs('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorApplicationsDefs('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog applicationdefs
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let applicationdef = this.editDialogsApplicationdefsService.applicationdefs;
    let original = this.editDialogsApplicationdefsService.originalApplicationdefs;
    return this.editDialogsApplicationdefsService.compare(applicationdef, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorApplicationsDefs(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
